import * as t from "io-ts"

export const DeviceSearchResult = t.intersection([
    t.type({
        displayValue: t.string,
        deviceRef: t.string,
        deviceModelNo: t.string,
        deviceManufacturer: t.string,
        deviceSize: t.number,
        deviceSizeName: t.string,
        deviceSizeUnit: t.string,
        devicePhases: t.string,
    }),
    t.partial({
        // PBI 71845: only meaningful for EVCP_AC suggest results. Three
        // possible shapes from API-Hybrid:
        //   - absent  — endpoint did not populate it (non-EVAC dataset)
        //   - null    — EVCP_AC exists but is not linked to a V2G inverter
        //   - string  — sysref of the linked V2G inverter (e.g. "TTR-INV-1")
        // The picker treats absent and null identically as "unlinked".
        v2gTtrStatus: t.union([t.string, t.null]),
    }),
])

export const DeviceSearchResults = t.array(DeviceSearchResult)

export type IDeviceSearchResult = t.TypeOf<typeof DeviceSearchResult>
